module.exports = __webpack_public_path__ + "media/src/public/img/promo-slide-bg-f7537e5fc44bf98a5392e0530cce6845.png";